import { PageFilter } from '../state/app';
import {
  ResponsibilityApprovalRequest,
  ResponsibilityApprovalRequestListFilter,
  ResponsibilityApprovalResponse,
} from '../state/responsibilityApprovalRequest';
import axios from '../utils/axios';

const baseUrl = `/api/responsibilityApprovalRequests`;

export const fetchResponsibilityApprovalRequestList = async ({
  filters,
  paging,
}: {
  filters: ResponsibilityApprovalRequestListFilter;
  paging: PageFilter;
}) => {
  const params = new URLSearchParams();
  params.append('cacheBuster', new Date().getTime().toString());
  params.append('pageSize', paging.pageSize.toString());
  params.append('pageNumber', paging.pageNumber.toString());

  Object.entries(filters).forEach(([key, value]) => {
    params.append(key, value);
  });
  const requestUrl = `${baseUrl}`;
  return await axios.get(`${requestUrl}?${params.toString()}`);
};

export const fetchResponsibilityApprovalRequest = async (
  id: ResponsibilityApprovalRequest['id'],
) => {
  const requestUrl = `${baseUrl}/${id}`;
  return await axios.get(requestUrl);
};

export const createResponsibilityApprovalRequest = async (
  responsibilityApprovalRequest: ResponsibilityApprovalRequest,
) => {
  const requestUrl = `${baseUrl}`;
  return await axios.post(requestUrl, responsibilityApprovalRequest);
};

export const updateResponsibilityApprovalRequest = async (
  responsibilityApprovalRequest: ResponsibilityApprovalRequest,
) => {
  const requestUrl = `${baseUrl}`;
  return await axios.put(requestUrl, responsibilityApprovalRequest);
};

export const updateResponsibilityApprovalResponse = async (
  responsibilityApprovalResponse: ResponsibilityApprovalResponse,
) => {
  const requestUrl = `${baseUrl}/${responsibilityApprovalResponse.responsibilityApprovalRequestId}/response`;
  return await axios.put(requestUrl, responsibilityApprovalResponse);
};
